import { Component, OnInit } from "@angular/core";
import { AppMainService } from "src/app/app-main.service";
import { ConfigurationService } from "../../configurationService";
import { ConfirmationService, MessageService } from "primeng/api";
import {
    VendorOAuthRegistrationService,
    VendorOAuthRegistrationUserService,
    VendorService,
} from "src/app/shared/shared-emails/Integration/api/api";
import {
    Vendor,
    VendorOAuthRegistration,
    VendorOAuthRegistrationUser,
} from "src/app/shared/shared-emails/Integration/model/models";
import { AccountUserService } from "src/app/service/account.service";
import { AppMainComponent } from "src/app/app.main.component";
@Component({
    selector: "app-smtp",
    templateUrl: "./smtp.component.html",
    styleUrls: ["./smtp.component.scss"],
})
export class SmtpComponent implements OnInit {
    products = [
        {
            id: 1,
            email: "invoice@mynexgenonline.com--test",
            password: "",
            cc: "",
            bcc: "",
            username: "invoice@mynexgenonline.com",
            server: "mynexgenonline-com.mail.protection.outlook.com",
            port: 25,
            isDefault: false,
            isActive: true,
        },
        {
            id: 2,
            email: "crm@liono360.com",
            password: "",
            cc: "",
            bcc: "",
            username: "AKIAIYOGWFCQ53KXLFPQ",
            server: "email-smtp.us-east-1.amazonaws.com",
            port: 587,
            isDefault: true,
            isActive: true,
        },
    ];
    vendorRegistrations = [];
    displaySelectServer = false;
    displayAddEditServer = false;
    serverHeader;
    showOthers: boolean;
    serverTemp = {
        id: 0,
        email: "",
        password: "",
        cc: "",
        bcc: "",
        username: "",
        server: "",
        port: 0,
        isDefault: false,
        isActive: false,
    };
    dialogType;
    vendorDetails;
    vendorSMTPData;
    globalFilterInput = "";
    windowRef = null;

    constructor(
        private app: AppMainComponent,
        private service: ConfigurationService,
        private appMainService: AppMainService,
        private messageService: MessageService,
        private confirmationService: ConfirmationService,
        private vendorRegistrationService: VendorOAuthRegistrationService,
        private accountService: AccountUserService,
        private vendorUserService: VendorOAuthRegistrationUserService
    ) {}

    ngOnInit(): void {
        this.getVendorRegistration();
        this.getSMTPVendorData();
    }

    getVendorRegistration() {
        this.appMainService.isShowSpinner("loadVendorRegistration");
        this.service.getAllVendorSMTPRegistration().subscribe(
            (res) => {
                this.vendorRegistrations = res;
                this.appMainService.isHideSpinner("loadVendorRegistration");
            },
            (err) => {
                this.appMainService.isHideSpinner("loadVendorRegistration");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred...",
                });
            }
        );
    }

    onGlobalSearch() {
        const searchColumns =
            "emailid,username,smtpserver,portin,portout,isactive,isdefault";
        this.appMainService.isShowSpinner("loadVendorRegistration");
        this.service
            .searchVendorSMTPRegistration(
                "0",
                "0",
                "",
                true,
                this.globalFilterInput,
                searchColumns
            )
            .subscribe(
                (res) => {
                    this.vendorRegistrations = res;
                    this.appMainService.isHideSpinner("loadVendorRegistration");
                },
                (err) => {
                    this.appMainService.isHideSpinner("loadVendorRegistration");
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: "Error occurred...",
                    });
                }
            );
    }

    eventCalled(c) {
        ////console.log(c);
        c.isDefault = true;
        this.appMainService.isShowSpinner("loadVendorRegistration");
        this.service.updateVendorSMTPRegistration(c).subscribe(
            (res) => {
                this.getVendorRegistration();
                this.appMainService.isHideSpinner("loadVendorRegistration");
                this.messageService.add({
                    severity: "success",
                    summary: "Success",
                    detail: "SMTP updated successfully...",
                });
            },
            (err) => {
                this.appMainService.isHideSpinner("loadVendorRegistration");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred...",
                });
            }
        );

        // if (c?.isDefault) {
        //     this.products.forEach((element) => {
        //         if (element.id != c.id) {
        //             element.isDefault = false;
        //         }
        //     });
        // }
    }

    newServer() {
        this.displaySelectServer = true;
    }

    addServer(c) {
        if (c == "AWS") {
            this.serverHeader = "AWS SES SMTP Setting";
            this.showOthers = false;
        } else if (c == "others") {
            this.serverHeader = "Other SMTP Setting";
            this.showOthers = true;
        } else if (c == "GMAIL") {
            this.serverHeader = "GMAIL SMTP Setting";
            this.showOthers = true;
        } else if (c == "OFFICE") {
            this.serverHeader = "OFFICE SMTP Setting";
            this.showOthers = true;
        }
        this.vendorDetails = null;
        this.displaySelectServer = false;
        this.displayAddEditServer = true;
        this.dialogType = "ADD";
    }

    // remove
    editServer(s) {
        if (s.server.includes("gmail.com")) {
            this.serverHeader = "Gmail SMTP Setting";
        } else if (s.server.includes("outlook.com")) {
            this.serverHeader = "Office365 SMTP Setting";
        } else if (s.server.includes("amazonaws.com")) {
            this.serverHeader = "AWS SES SMTP Setting";
        } else {
            this.serverHeader = "Other SMTP Setting";
        }
        this.serverTemp = JSON.parse(JSON.stringify(s));
        this.dialogType = "EDIT";
        this.displayAddEditServer = true;
    }

    editServer1(s) {
        if (s.serverName.includes("gmail.com")) {
            this.serverHeader = "Gmail SMTP Setting";
        } else if (s.serverName.includes("outlook.com")) {
            this.serverHeader = "Office365 SMTP Setting";
        } else if (s.serverName.includes("amazonaws.com")) {
            this.serverHeader = "AWS SES SMTP Setting";
        } else {
            this.serverHeader = "Other SMTP Setting";
        }
        this.vendorDetails = null;
        this.appMainService.isShowSpinner("loadVendorRegistration");
        this.service.getVendorSMTPRegistrationById(s.id).subscribe(
            (res) => {
                this.vendorDetails = res;
                this.dialogType = "EDIT";
                this.appMainService.isHideSpinner("loadVendorRegistration");
                this.displayAddEditServer = true;
            },
            (err) => {
                this.appMainService.isHideSpinner("loadVendorRegistration");
                this.messageService.add({
                    severity: "error",
                    summary: "Error",
                    detail: "Error occurred...",
                });
            }
        );
    }

    deleteServer(s) {
        this.confirmationService.confirm({
            message: "Do you want to delete?",
            header: "Delete Confirmation",
            icon: "pi pi-info-circle",
            accept: () => {
                this.appMainService.isShowSpinner("loadVendorRegistration");
                this.service.deleteVendorSMTPRegistration(s.id).subscribe(
                    (res) => {
                        this.messageService.add({
                            severity: "success",
                            summary: "Success",
                            detail: "Deleted successfully...",
                        });
                        this.getVendorRegistration();
                        this.appMainService.isHideSpinner(
                            "loadVendorRegistration"
                        );
                    },
                    (err) => {
                        this.appMainService.isHideSpinner(
                            "loadVendorRegistration"
                        );
                        this.messageService.add({
                            severity: "error",
                            summary: "Error",
                            detail: "Error occurred...",
                        });
                    }
                );
            },
            reject: () => {},
        });
    }

    onSaveComplete(e) {
        this.dialogType = null;
        this.displayAddEditServer = false;
        this.getVendorRegistration();
    }

    onCancelClicked(e) {
        this.dialogType = null;
        this.displayAddEditServer = false;
    }

    configureEmail(client: Vendor) {
        this.vendorRegistrationService
            .lionO36020APIVendorOAuthRegistrationIdGet(client.id)
            .toPromise()
            .then((res: VendorOAuthRegistration) => {
                // console.log('Res -->>', res);
                const loggedinUser = this.accountService.userValue;
                let userInfo = {
                    organizationId: loggedinUser.organizationId,
                    // userId: loggedinUser.userId,
                    vendorId: res.vendorId,
                    clientIP: res.createdSource,
                    loginAuditId: loggedinUser.loginAuditId,
                    authToken: loggedinUser.token,
                    sessionId: localStorage.getItem("randomstr"),
                    sourceType: "Web",
                };
                let objEncStr = btoa(JSON.stringify(userInfo));
                let url = "";
                // debugger;
                if (res.name === "MSGraph") {
                    url = `${res.registrationURL}client_id=${res.clientId}&redirect_uri=${res.redirectURL}&response_type=code&scope=openid+offline_access+profile+User.Read+Mail.Read+Mail.Send+Mail.ReadWrite+Group.ReadWrite.All+Directory.ReadWrite.All+Tasks.ReadWrite+Calendars.ReadWrite&state=${objEncStr}`;
                } else if (res.name === "GmailAPI") {
                    url = `https://accounts.google.com/o/oauth2/auth?response_type=code&redirect_uri=${res.redirectURL}&state=${objEncStr}&access_type=offline&approval_prompt=force&scope=https://www.googleapis.com/auth/gmail.compose+https://www.googleapis.com/auth/gmail.readonly&client_id=${res.clientId}`;
                }
                // console.log('URL -->>', url);
                this.windowRef = window.open(
                    url,
                    "child",
                    "toolbar=no,location=no,directories=no,status=no,menubar=no,titlebar=no,fullscreen=no,scrollbars=1,resizable=no,width=1000,height=650,left=200,top=100"
                );

                let windowRefInterval = setInterval(() => {
                    this.vendorUserService
                        .lionO36020APIVendorOAuthRegistrationUserUserIdGet()
                        .toPromise()
                        .then((res: VendorOAuthRegistrationUser) => {
                            if (res) {
                                this.app.isConfigured = res.statusId !== 2;
                                this.app.configuredUser =
                                    res.statusId !== 2 ? res : null;
                                // this.displayConfigureEmail = false;
                                this.app.configuredUserBSubject.next(
                                    this.app.isConfigured
                                );

                                this.app.getAllObjects();
                                //this.app.getAllActivityLog("lastsevendays", "allactivity", 1, 10, "", true, true);
                                if (this.windowRef) {
                                    this.windowRef.close();
                                }
                                clearInterval(windowRefInterval);
                            }
                        });
                }, 500);
            });
    }

    getSMTPVendorData(){
        this.service.getSMTPVendor().subscribe(data=>{
            this.vendorSMTPData = data?.filter(vendor => vendor?.name?.toLowerCase() == 'other smtps')[0];
        })
    }
}
